interface IDataLayerContract {
  event: string
  event_category: string
}

const CITADELE_PAGE_TYPE = 'citadele_page'

export const CITADELE_APPLY_FOR_CARD_CONTRACT = {
  event: 'c_apply_for_card',
  event_category: 'citadele_card',
  page_type: CITADELE_PAGE_TYPE
} as const

export const CITADELE_JOIN_BT_CLUB_CONTRACT = {
  event: 'c_join_bt_club',
  event_category: 'bt_club',
  page_type: CITADELE_PAGE_TYPE
} as const

const DATA_LAYER_CONTRACTS_BY_PAGE_TYPE: Record<string, IDataLayerContract[]> = {
  [CITADELE_PAGE_TYPE]: [CITADELE_APPLY_FOR_CARD_CONTRACT, CITADELE_JOIN_BT_CLUB_CONTRACT]
}

export function isKnownDataLayerContractValid(data: { event: string; event_category: string; page_type: string }) {
  const contracts = DATA_LAYER_CONTRACTS_BY_PAGE_TYPE[data.page_type]

  if (!contracts) {
    return true
  }

  return contracts.some((contract) => contract.event === data.event && contract.event_category === data.event_category)
}
